import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface ICreateInvoicesFromItemsRequest extends IBaseRequest {
    FOLDERS?:      Record[];
    PROJECTS?:     Record[];
    ACTIVITIES?:   Record[];
    ITEMS?:        Record[];
    DOCUMENTTYPE?: string;
}

export interface Record {
    id: string;
}

export class CreateInvoicesFromItemsRequest extends BaseRequest implements ICreateInvoicesFromItemsRequest {

  FOLDERS?:      Record[];
  PROJECTS?:     Record[];
  ACTIVITIES?:   Record[];
  ITEMS?:        Record[];
  DOCUMENTTYPE?: string;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.FOLDERS = otherOptions.FOLDERS;
    this.PROJECTS = otherOptions.PROJECTS;
    this.ACTIVITIES = otherOptions.ACTIVITIES;
    this.ITEMS = otherOptions.ITEMS;
    this.DOCUMENTTYPE = otherOptions.DOCUMENTTYPE;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNodeArray(this.FOLDERS, record => `<id>${record.id}</id>`, 'FOLDERS');
    parameters += this.makeNodeArray(this.PROJECTS, record => `<id>${record.id}</id>`, 'PROJECTS');
    parameters += this.makeNodeArray(this.ACTIVITIES, record => `<id>${record.id}</id>`, 'ACTIVITIES');
    parameters += this.makeNodeArray(this.ITEMS, record => `<id>${record.id}</id>`, 'ITEMS');
    parameters += this.makeNode(this.DOCUMENTTYPE || '', 'documentType');
    return super.wrapperXml('CreateInvoicesFromItems', parameters);

  }
}
